var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'d-inline-block': _vm.btnInline}},[(!_vm.isRecording)?_c('button',{staticClass:"btn uppercase",class:{
            'w-72': !_vm.btnInline,
            'w-full h-full': _vm.gridLayout,
            'line-height-normal': _vm.btnLineHeight,
            'btn-primary--brand btn-record': _vm.btnPrimary
        },on:{"click":_vm.toggleRecorder}},[_vm._t("StartBtnLabel",function(){return [_vm._v("Stimme aufnehmen")]})],2):_vm._e(),_vm._v(" "),(_vm.isRecording)?_c('button',{staticClass:"btn uppercase",class:{
            'btn-primary--brand w-72': _vm.btnPrimary,
            'w-full h-full': _vm.gridLayout,
            'line-height-normal': _vm.btnLineHeight
        },attrs:{"disabled":_vm.isCountdown || _vm.initUserMedia},on:{"click":_vm.stopRecorder,"mousedown":_vm.stopRecorder}},[_vm._v(_vm._s(_vm.showTime ? ("Aufnahme stoppen: " + _vm.recordedTime + " sek") : 'Aufnahme stoppen'))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }